import { Button, Flex, Modal } from 'antd';
import RejectIcon from '../assets/icons/RejectIcon';
import SuccessIcon from '../assets/icons/SuccessIcon';
import { cn } from '../lib/cn';

type Props = {
  open: boolean;
  handleClose?: (val?: boolean) => void;
  type: 'SUCCESS' | 'REJECT';
};

export default function PaymentModal({ open, handleClose, type }: Props) {
  const content = system[type];

  return (
    <Modal
      width={400}
      open={open}
      footer={null}
      closable={false}
      centered={true}
      className={cn('custom-modal ')}
      rootClassName="custom-bg-modal"
      onCancel={() => handleClose?.(true)}
    >
      <div className="space-y-[30px] py-[10px] px-5">
        <Flex justify="center">{content.icon}</Flex>
        <div className="text-center">
          <h3 className="text-center text-white text-2xl font-bold leading-9">
            {content.title}
          </h3>
          <p className="text-center justify-start text-white text-lg font-normal mt-2 leading-6">
            {content.subTitle}
          </p>
        </div>

        <Button block type="primary" onClick={() => handleClose?.(true)}>
          Close
        </Button>
      </div>
    </Modal>
  );
}

const system = {
  SUCCESS: {
    icon: <SuccessIcon />,
    title: 'Payment Successful !',
    subTitle: 'Thank you for your purchase',
  },
  REJECT: {
    icon: <RejectIcon />,
    title: 'Payment Rejected !',
    subTitle: "Couldn't process your payment. Please try again!",
  },
};
